import { NodeType } from "../NodeType";

export {
  CompletionStatus,
  EndAction,
  ArchiveReason,
  TEndNode,
  TEndNodeConfig,
  TDefaultEndNodeConfig,
  TArchiveConversationEndNodeConfig,
  TWebhookNotificationEndNodeConfig,
  TWebhook,
  defaultEndNode,
  defaultEndActionNode,
  defaultWebhookNotificationEndActionNode,
  defaultArchiveConversationEndActionNode,
};

type TEndNode = {
  name: string;
  description?: string;
  nodeId: string;
  type: typeof NodeType.END;
  config: TEndNodeConfig;
};

const CompletionStatus = {
  COMPLETED: "completed",
  FAILED: "failed",
  CANCELLED: "cancelled",
} as const;

const EndAction = {
  NONE: "none",
  ARCHIVE_CONVERSATION: "archive_conversation",
  WEBHOOK_NOTIFICATION: "webhook_notification",
} as const;

const ArchiveReason = {
  RESOLVED: "resolved",
  TIMED_OUT: "timed_out",
  MANUAL: "manual",
  ERROR: "error",
  OTHER: "other",
} as const;

type ArchiveReason = (typeof ArchiveReason)[keyof typeof ArchiveReason];
type EndAction = (typeof EndAction)[keyof typeof EndAction];
type CompletionStatus =
  (typeof CompletionStatus)[keyof typeof CompletionStatus];

type TEndNodeConfig =
  | TDefaultEndNodeConfig
  | TArchiveConversationEndNodeConfig
  | TWebhookNotificationEndNodeConfig;

type TDefaultEndNodeConfig = {
  name: string;
  description?: string;
  completionStatus: typeof CompletionStatus;
  endAction: typeof EndAction.NONE;
};

type TArchiveConversationEndNodeConfig = {
  name: string;
  description?: string;
  completionStatus: typeof CompletionStatus;
  endAction: typeof EndAction.ARCHIVE_CONVERSATION;
  archiveReason: typeof ArchiveReason;
};

type TWebhookNotificationEndNodeConfig = {
  name: string;
  description?: string;
  completionStatus: typeof CompletionStatus;
  endAction: typeof EndAction.WEBHOOK_NOTIFICATION;
  webhookList: Array<TWebhook>;
  maxRetries?: number;
  retryDelayMs: number;
};

type TWebhook = {
  webhookName: string;
  endpointUrl: string;
  authRequired?: boolean;
  authKey?: boolean;
};

const defaultEndActionNode = {
  name: "End",
  description: "",
  completionStatus: CompletionStatus.COMPLETED,
  endAction: EndAction.NONE,
};

const defaultWebhookNotificationEndActionNode = {
  name: "End - Webhook Notification",
  description: "",
  completionStatus: CompletionStatus.COMPLETED,
  endAction: EndAction.WEBHOOK_NOTIFICATION,
  webhookList: [],
  maxRetries: 0,
  retryDelayMs: 0,
};

const defaultArchiveConversationEndActionNode = {
  name: "End - Archive Conversation",
  description: "",
  completionStatus: CompletionStatus.COMPLETED,
  endAction: EndAction.ARCHIVE_CONVERSATION,
  archiveReason: ArchiveReason.RESOLVED,
};

const defaultEndNode = {
  [EndAction.NONE]: defaultEndActionNode,
  [EndAction.WEBHOOK_NOTIFICATION]: defaultWebhookNotificationEndActionNode,
  [EndAction.ARCHIVE_CONVERSATION]: defaultArchiveConversationEndActionNode,
};
